<template>
  <div class="tax-block">
    <div class="tax-block__row grid">
      <p class="tax-block__text">Tax %</p>

      <p class="tax-block__text red" v-if="!estimateStore.estimate.taxLimit">
        We do not charge taxes here yet
      </p>
      <p v-else></p>
      <p class="tax-block__text right" v-if="!estimateStore.estimate.taxLimit">
        -
      </p>
      <p class="tax-block__text right" v-else>
        {{ estimateStore.estimate.taxPercent }}
      </p>
    </div>
    <div class="tax-block__row">
      <p class="tax-block__text">Tax SUM</p>
      <p class="tax-block__text" v-if="!estimateStore.estimate.taxLimit">-</p>
      <div v-else>
        <p class="tax-block__text right">{{ estimateStore.estimate.taxSum }}</p>
      </div>
    </div>
    <div class="tax-block__row">
      <p class="tax-block__text">Tax exempt</p>
      <CheckboxField
        v-model="estimateStore.estimate.isTaxExempt"
        :disabled="!estimateStore.estimate.taxLimit"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { useEstimateReviewStore } from "@/stores/new/estimateReview.store";

import { PriceValue, CheckboxField } from "@/shared";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { PricingService } from "@/app/services/pricing.service";
import { Pricing } from "@/app/domain/entities/pricing";

const estimateReviewStore = useEstimateReviewStore();
const estimateStore = useNewEstimateStore();
const pricingService = new PricingService();

const calculateTaxSumPrice = () => {
  if (
    estimateStore.estimate.taxSum === 0 &&
    estimateStore.estimate.isTaxExempt
  ) {
    return;
  }
  const taxSum = pricingService.calculateTaxSumPrice();
  const formattedTaxSum = new Pricing(
    taxSum.price,
    taxSum.priceB2C,
    taxSum.priceB2B,
  );
  estimateStore.estimate.taxSum = formattedTaxSum
    .getSystemPrice(estimateStore.estimate.dealTypeCode)
    .getValue();
};

watch(
  () => [estimateReviewStore.subtotalPrice],
  () => {
    calculateTaxSumPrice();
  },
  {
    deep: true,
    immediate: true,
  },
);

watch(
  () => estimateStore.estimate.taxPercent,
  (taxPercent) => {
    estimateStore.estimate.taxPercent = taxPercent;
  },
  {
    deep: true,
    immediate: true,
  },
);

watch(
  () => estimateStore.estimate.isTaxExempt,
  (isTaxExempt) => {
    if (isTaxExempt) {
      estimateStore.estimate.taxSum = 0;
    } else {
      calculateTaxSumPrice();
    }
  },
  {
    deep: true,
    immediate: true,
  },
);
</script>

<style scoped>
.tax-block {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.tax-block__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tax-block__row.grid {
  display: grid;
  grid-template-columns: 60% 35% 5%;
  align-items: center;
}

.tax-block__text {
  font-weight: 400;
  font-size: 13px;
  line-height: 100%;
  color: #052141;
}

.tax-block__text.right {
  text-align: right;
}

.tax-block__text.red {
  margin-right: 20%;
  color: #ff0909;
}
</style>
